module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2017_05.5e9e4c0b.jpg";